import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-modal-add-commercial",
  templateUrl: "./modal-add-commercial.component.html",
  styleUrls: ["./modal-add-commercial.component.scss"],
})
export class ModalAddCommercialComponent implements OnInit {
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true;
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  endPoint: string = "commercial";
  title: string = "commercial";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];

  gender = "M";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay(),
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeAvenant: any[];
  itemsModeCreationAvenant = [
    { code: "MANU", libelle: "Manuel" },
    { code: "AUTO", libelle: "Automatique" },
  ];
  currentData: any;
  itemsTypeCourtier: any;
  itemsVille: any;
  itemsAgence: any;
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer,
    public bsModalRef: BsModalRef,
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.deleteMessage =
      "Vous êtes sur le point de supprimer " + text1 + " " + this.title;

    setTimeout(() => {
      this.itemToSave = Object.assign({}, this.currentData);
      console.log("itemToSave! ", this.itemToSave);
      if (this.currentData) {
        this.itemToSave.date_effet = moment(
          this.itemToSave.date_effet,
        ).toDate();
        // this.onChangeTypeCourtier()
      }
    }, 300);
  }

  load_filiale_data() {
    // this.getItems();
    this.getItemsFiliale();
  }

  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => {},
      );
  }
  getItemsTypeAvenant() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeAvenant/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeAvenant = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"],
            );
          } else {
            this.itemsTypeAvenant = [];
          }
        },
        (err) => {
          this.itemsTypeAvenant = [];
        },
      );
  }

  saveItem(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    itemAEnregistrer.filiale_id = this.filiale_id || this.user.filiale_id;
    var request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request,
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center",
            );
            this.currentPage = 0;
            this.bsModalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center",
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            err || this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center",
          );
          this.loading = false;
        },
      );
  }
  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }
  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  uploadFile(event: any) {
    console.log("event: ", event);
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split(".")[0];
      const Tabextension = file.name.split(".");
      const extension = Tabextension[Tabextension.length - 1];

      console.info("fileName", fileName);
      console.info("extension", extension);
      this.imageName = fileName + "." + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(",")[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: "custom type",
        };
        // console.log('currentItemImage: ',this.currentItemImage)
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onChangeTypeCourtier() {
    if (this.itemsTypeCourtier && this.itemsTypeCourtier.length)
      this.itemToSave.type_courtier_code = this.itemsTypeCourtier.filter(
        (its) => its.id == this.itemToSave.type_courtier_id,
      )[0].codification;
  }

  getItemsTypeCourtier() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      order_by: "libelle",
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeCourtier/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsTypeCourtier", res);

          if (res && res["items"]) {
            this.itemsTypeCourtier = res["items"];
          } else {
            this.itemsTypeCourtier = [];
          }
        },
        (err) => {
          this.itemsTypeCourtier = [];
        },
      );
  }

  getItemsVille() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("ville/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsVille", res);

          if (res && res["items"]) {
            this.itemsVille = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsVille = [];
          }
        },
        (err) => {},
      );
  }

  getItemsAgence() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("agence/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsAgence", res);

          if (res && res["items"]) {
            this.itemsAgence = _.orderBy(res["items"], ["libelle"], ["asc"]);
          } else {
            this.itemsAgence = [];
          }
        },
        (err) => {
          this.itemsAgence = [];
        },
      );
  }

  confirmSaveItem(item) {
    console.info("item: ", item);

    console.info(" itemToSave ", this.itemToSave);
    console.info(" item ", item);

    if (!item.id && !item.code) item.code = this.generateUniqueString();

    // if (!item || !item.codification) {
    //   this.utilities.showNotification(
    //     "snackbar-danger",
    //     "Veuillez renseigner codification !",
    //     "bottom",
    //     "center"
    //   );
    //   return;
    // }
    // item.specialiteId = this.selectedSpecialite.id
    if (!item || !item.nom) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner nom !",
        "bottom",
        "center",
      );
      return;
    }

    if (!item || !item.prenom) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner prenom !",
        "bottom",
        "center",
      );
      return;
    }

    if (!item || !item.agence_id) {
      this.utilities.showNotification(
        "snackbar-danger",
        "Veuillez renseigner agence !",
        "bottom",
        "center",
      );
      return;
    }

    let objToSave = Object.assign({}, item);

    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0665aa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        // ;
        this.saveItem(objToSave);
      }
    });
  }

  ngOnInit(): void {
    this.load_filiale_data();
    this.getItemsAgence();
  }
}
